import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { getUtility, Icon, SimpleModal } from '@livable/saas-react-components';
import { Button, Typography } from '@mui/material';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { VACANT_UNIT_ALLOCATIONS, vacantUnitOccupantsCountToSave } from 'src/constants/utilities';
import useStyles from './styles';
import VacantUnitBillsContent from './VacantUnitBillsContent';
import { useStore } from 'src/stores';
const VacantUnitBills = _ref => {
  let disabledTrigger = _ref.disabledTrigger,
    propertyUtility = _ref.propertyUtility;
  const classes = useStyles();
  const store = useStore();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    modalState = _useState2[0],
    setModalState = _useState2[1];
  // Read from the utility each time the modal opens, not once at mount: the setup list keeps this component
  // mounted across renders, and the allocation can change on the utility meanwhile (a utility type pick sets it).
  const currentAllocation = () => propertyUtility.vacantUnitAllocation || VACANT_UNIT_ALLOCATIONS.DivideAmongOccupied;
  const _useState3 = useState(currentAllocation),
    _useState4 = _slicedToArray(_useState3, 2),
    localVacantUnitAllocation = _useState4[0],
    setLocalVacantUnitAllocation = _useState4[1];
  const openModal = () => {
    setLocalVacantUnitAllocation(currentAllocation());
    setModalState(true);
  };
  const modalTitle = /*#__PURE__*/React.createElement("div", {
    className: classes.modalHeader
  }, /*#__PURE__*/React.createElement("span", null, getUtility(propertyUtility.utilityType).icon({
    pattern: 'gradient'
  })), /*#__PURE__*/React.createElement(Typography, {
    variant: "h3"
  }, getUtility(propertyUtility.utilityType).title, " ", t('add_new_property_flow.configuration')), /*#__PURE__*/React.createElement(Typography, {
    variant: "h5",
    color: "light"
  }, "/ ", t('add_new_property_flow.handling_vacant_unit')));
  const modalSubTitle = /*#__PURE__*/React.createElement("div", {
    className: classes.flex
  }, propertyUtility.provider.utilityProviderName);
  const trigger = /*#__PURE__*/React.createElement(Button, {
    variant: "actionButton",
    onClick: openModal,
    'custom-attribute': '644-new-billing-module'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "edit"
  }), /*#__PURE__*/React.createElement("span", {
    className: "actionText"
  }, t('general.edit')));
  const handleClose = e => {
    e === null || e === void 0 || e.preventDefault();
    setModalState(false);
  };
  const handleSave = _ref2 => {
    let vacantUnitUsage = _ref2.vacantUnitUsage,
      vacantUnitUsageLimit = _ref2.vacantUnitUsageLimit,
      vacantUnitOccupantsCount = _ref2.vacantUnitOccupantsCount;
    propertyUtility.setVacantUnitAllocation(localVacantUnitAllocation);
    propertyUtility.setVacantUnitUsage(vacantUnitUsage);
    propertyUtility.setVacantUnitUsageLimit(vacantUnitUsageLimit);
    if (store.company.companyFeatureStore.enableVacantUnitOccupantsCount) {
      propertyUtility.setVacantUnitOccupantsCount(vacantUnitOccupantsCountToSave(true, vacantUnitUsage, vacantUnitOccupantsCount));
    }
    setModalState(false);
  };
  return /*#__PURE__*/React.createElement(SimpleModal, {
    disabledTrigger: disabledTrigger,
    handleClose: handleClose,
    handleOpen: openModal,
    isOpen: modalState,
    noFooter: true,
    noLeftButton: true,
    noMargin: true,
    subTitle: modalSubTitle,
    title: modalTitle,
    trigger: trigger,
    variant: "staticHeight"
  }, /*#__PURE__*/React.createElement(VacantUnitBillsContent, {
    handleSave: handleSave,
    propertyUtility: propertyUtility
  }));
};
export default VacantUnitBills;